import { NgOptimizedImage } from '@angular/common';
import {
  Component, Input, OnChanges,
} from '@angular/core';
import { EntityService } from 'src/app/services/entity.service';

@Component({
  selector: 'app-entity-logo',
  template: `
    <img
      *ngIf="logoUrl"
      [src]="logoUrl" [alt]="altText" class='image' [ngClass]="customClass"/>
    <div *ngIf="isLoading" class="logo-placeholder">
    </div>
  `,
  styles: [
    `
    img.image {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .logo-placeholder {
      width: 100%;
      height: 100%;
      background-color: #f0f0f0;
      border-radius: 4px;
    }
  `,
  ],
})
export class EntityLogoComponent implements OnChanges {
  @Input() loginName: string | null = null;
  @Input() altText = 'Entity logo';
  @Input() customClass = 'entity-logo';

  logoUrl: string | null = null;
  isLoading = false;

  constructor(private entityService: EntityService) { }

  ngOnChanges(): void {
    this.loadLogo();
    this.entityService.reloadLogo$.subscribe(() => this.loadLogo());
  }

  private loadLogo(): void {
    if (!this.loginName) return;

    this.isLoading = true;

    this.entityService.getEntityLogo(this.loginName).subscribe({
      next: (response: any) => {
        if (response?.data?.logoUrl) {
          this.logoUrl = response.data.logoUrl;
        } else {
          console.error('No logo URL found in response:', response);
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Failed to load entity logo:', error);
        this.isLoading = false;
      },
    });
  }
}
